import React, { useRef, useState } from 'react';
import { HiOutlineChevronDown } from 'react-icons/hi';
import styled from 'styled-components';

import { Content, FoldableLayout, Inner, Trigger, TriggerIcon, TriggerText } from './styles.Foldable';
import { mobile } from '../../../styles/variables';

interface FoldableProps {
    triggerText?: string | React.ReactNode;
    isResponsive?: boolean;
    showDivider?: boolean;
    arrowColor?: string;
    arrowBackground?: string;
    arrowRight?: boolean;
    className?: string;
}

export const Foldable: React.FC<FoldableProps> = ({
    children,
    triggerText,
    isResponsive,
    showDivider,
    arrowColor,
    arrowBackground,
    arrowRight,
    className
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    const handleTrigger = () => {
        setIsOpen(!isOpen);
    };

    return (
        <FoldableLayout isResponsive={isResponsive} className={className}>
            <Trigger onClick={handleTrigger} showDivider={showDivider}>
                {isResponsive ? null : (
                    <TriggerIcon
                        open={isOpen}
                        responsive={isResponsive}
                        arrowColor={arrowColor}
                        arrowBackground={arrowBackground}
                        arrowRight={arrowRight}
                    >
                        <HiOutlineChevronDown />
                    </TriggerIcon>
                )}
                <TriggerText isResponsive={isResponsive}>{triggerText}</TriggerText>
                {isResponsive ? (
                    <TriggerIcon
                        open={isOpen}
                        responsive={isResponsive}
                        arrowColor={arrowColor}
                        arrowBackground={arrowBackground}
                        arrowRight={arrowRight}
                    >
                        <HiOutlineChevronDown />
                    </TriggerIcon>
                ) : null}
            </Trigger>
            <Content ref={ref} isOpen={isOpen} height={ref.current?.scrollHeight} isResponsive={isResponsive}>
                <Inner isResponsive={isResponsive}>{children}</Inner>
            </Content>
        </FoldableLayout>
    );
};

export const MobileFoldable = styled(Foldable)`
    display: none;

    @media ${mobile} {
        display: block;
    }
`;
